/**
 * Portal Manta · SubSidebar
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';

const SubSidebar = memo(function SubSidebar_Inner({groups, activeKey, onSelect, storageKey}){
  const SK_COL = (storageKey||'manta-subsidebar') + ':col';
  const SK_GRP = (storageKey||'manta-subsidebar') + ':grp';

  const [collapsed, setCollapsed] = useState(()=>{
    if (typeof window === 'undefined') return false;
    return window.localStorage?.getItem(SK_COL) === '1';
  });
  const [openGroups, setOpenGroups] = useState(()=>{
    // padrão: abre o grupo que contém a aba ativa; demais ficam abertos também (UX defensiva)
    let saved = null;
    if (typeof window !== 'undefined') {
      try { saved = JSON.parse(window.localStorage?.getItem(SK_GRP) || 'null'); } catch {}
    }
    if (saved && typeof saved === 'object') return saved;
    const init = {};
    groups.forEach(g => { init[g.id] = true; });
    return init;
  });

  useEffect(()=>{
    if (typeof window !== 'undefined') {
      window.localStorage?.setItem(SK_COL, collapsed ? '1' : '0');
    }
  }, [collapsed, SK_COL]);
  useEffect(()=>{
    if (typeof window !== 'undefined') {
      try { window.localStorage?.setItem(SK_GRP, JSON.stringify(openGroups)); } catch {}
    }
  }, [openGroups, SK_GRP]);

  const W = collapsed ? 38 : 158;

  return (<div style={{
    width: W, flexShrink: 0, background: '#fff',
    borderRight: '1px solid '+V.b1,
    display: 'flex', flexDirection: 'column',
    transition: 'width .25s', overflow:'hidden'
  }}>
    {/* Header com toggle de colapso */}
    <div style={{
      padding: '5px 6px', borderBottom: '1px solid '+V.g1,
      display:'flex', alignItems:'center', justifyContent: collapsed?'center':'flex-end',
      flexShrink:0
    }}>
      <span
        onClick={()=>setCollapsed(c=>!c)}
        title={collapsed?'Expandir sub-abas':'Colapsar sub-abas'}
        style={{
          cursor:'pointer', fontSize:11, fontWeight:700, color:V.gr,
          padding:'2px 8px', background:V.g0, borderRadius:4,
          userSelect:'none', lineHeight:1
        }}
      >{collapsed?'›':'‹'}</span>
    </div>
    {/* Lista */}
    <div style={{flex:1, overflowY:'auto', padding:'4px 0'}}>
      {groups.map(g => {
        const isOpen = collapsed || openGroups[g.id] !== false;
        return (<Fragment key={g.id}>
          {!collapsed && groups.length > 1 && (
            <div
              onClick={()=>setOpenGroups(s=>({...s, [g.id]: !(s[g.id]!==false)}))}
              style={{
                padding:'7px 12px 4px', fontSize:8.5, fontWeight:800,
                color:V.g4, textTransform:'uppercase', letterSpacing:'.07em',
                cursor:'pointer', userSelect:'none',
                display:'flex', alignItems:'center', gap:5
              }}
            >
              <span style={{
                fontSize:9, transition:'transform .2s',
                transform: isOpen?'rotate(90deg)':'',
                color: isOpen?V.bl:V.g3, display:'inline-block'
              }}>▸</span>
              <span>{g.label}</span>
            </div>
          )}
          {!collapsed && groups.length === 1 && (
            <div style={{
              padding:'4px 12px 6px', fontSize:8.5, fontWeight:800,
              color:V.g4, textTransform:'uppercase', letterSpacing:'.07em'
            }}>{g.label}</div>
          )}
          <div style={{
            maxHeight: isOpen ? 800 : 0,
            overflow:'hidden', transition:'max-height .25s'
          }}>
            {(g.items||[]).map(it => {
              const ativo = it.k === activeKey;
              const badge = it.badge != null ? it.badge : (it.n != null ? it.n : (it.k||'').toString().slice(0,2));
              return (<div
                key={it.k}
                onClick={()=>onSelect(it.k)}
                title={it.l + (it.sub?' · '+it.sub:'')}
                style={{
                  padding: collapsed ? '5px 0' : '6px 10px',
                  cursor:'pointer',
                  display:'flex', gap:8, alignItems:'center',
                  justifyContent: collapsed?'center':'flex-start',
                  borderLeft: '2px solid '+(ativo?V.or:'transparent'),
                  background: ativo ? '#FDF0E8' : 'transparent',
                  transition:'all .12s'
                }}
              >
                <span style={{
                  width:20, height:20, flexShrink:0, borderRadius:4,
                  background: ativo?V.or:V.g0,
                  color: ativo?'#fff':V.gr,
                  fontSize:9.5, fontWeight:800,
                  display:'flex', alignItems:'center', justifyContent:'center'
                }}>{badge}</span>
                {!collapsed && (
                  <div style={{minWidth:0, flex:1}}>
                    <div style={{
                      fontSize:10.5, fontWeight:700, color:V.br,
                      whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'
                    }}>{it.l}</div>
                    {it.sub && (<div style={{
                      fontSize:8.5, color:V.gr,
                      whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'
                    }}>{it.sub}</div>)}
                  </div>
                )}
              </div>);
            })}
          </div>
        </Fragment>);
      })}
    </div>
  </div>);
});

export { SubSidebar };
export default SubSidebar;
